import jsSHA from "jssha";

export const changeCheckedItem = (list, id) => {
  list.slice().forEach((item) => (item.isChecked = item.id === id));

  return list;
};

export const createUUIDv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const capitalize = (string) =>
  `${string.charAt(0).toUpperCase()}${string.slice(1)}`;

export const findSelectedItem = (items) => {
  return items.find((item) => item.isChecked);
};

export const getItemById = (list, id) => {
  return list.find((item) => item.id === id);
};


export const stringToDate = (_date,_format,_delimiter) =>{
  const formatLowerCase=_format.toLowerCase();
  const formatItems=formatLowerCase.split(_delimiter);
  const dateItems=_date.split(_delimiter);
  const monthIndex=formatItems.indexOf("mm");
  const dayIndex=formatItems.indexOf("dd");
  const yearIndex=formatItems.indexOf("yyyy");
  let month=parseInt(dateItems[monthIndex]);
  month-=1;
  const formatedDate = new Date(dateItems[yearIndex],month,dateItems[dayIndex]);
  return formatedDate;
}

const addZiro = (num) => {
  if (num < 10) num = `0${num}`
  return `${num}` 
}

export const DateIsoToRus = (_date, timeEnable = true) => {
  if (_date  == null) return;
  if (timeEnable) return `${addZiro(_date.getDate())}.${addZiro(_date.getMonth() + 1)}.${_date.getFullYear()} ${addZiro(_date.getHours())}:${addZiro(_date.getMinutes())}`
  return `${addZiro(_date.getDate())}.${addZiro(_date.getMonth() + 1)}.${_date.getFullYear()}`; 
}

export const StringIsoDateToRus = (_date) => {
  if (_date  == null) return;

  const formatedDate = `${_date.slice(8,10)}.${_date.slice(5,7)}.${_date.slice(0,4)} ${_date.slice(11,16)}`;
  return formatedDate; 
}



// export const prepareAdditionalItems = (item) => {
//   return {
//     ...item,
//     quantity: 0,
//   };
// };

export const getImageSources = (src) => {
  const getDefaultSrc = (src) =>
    `${src.replace(".jpg", "@2x.jpg")} 2x, ${src.replace(
      ".jpg",
      "@4x.jpg"
    )} 4x`;

  const getWebPSrc = (src) =>
    `${src.replace(".jpg", ".webp")} 1x, ${src.replace(
      ".jpg",
      "@2x.webp"
    )} 2x, ${src.replace(".jpg", "@4x.webp")} 4x`;

  return {
    webpSrcset: getWebPSrc(src),
    srcset: getDefaultSrc(src),
  };
};


export const generateSHA512Hash = async (data) => {
  // Encode the data as UTF-8
  const encoder = new TextEncoder();
  const dataBuffer = encoder.encode(data);

  // Compute the hash
  const hashBuffer = await window.crypto.subtle.digest('SHA-512', dataBuffer);

  // Convert the hash to a hexadecimal string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');

  return hashHex;
}

// Стандартный метод(generateSHA512Hash) не работает с адресами по IP Ограничение WEB API браузера
export const generateSHA512HashWorkWithIP = (data) => {
  // const encoder = new TextEncoder();
  // const dataBuffer = encoder.encode(data);
  const shaObj = new jsSHA("SHA-512", "TEXT", { encoding: "UTF8" });
  shaObj.update(data);
  /* .update() can be chained */
  // shaObj.update("This is").update(" a ");
  // shaObj.update("test");
  const hashHex = shaObj.getHash("HEX");

  return hashHex;
}


export const copyStylesToIFrame = (frame_id) => {
  const iframe = document.getElementById(frame_id);
  if (!iframe) return;
  const doc = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument);
  document.head.querySelectorAll("style").forEach((style) => {
    doc?.document.head.append(style.cloneNode(true));
  });
  document.head.querySelectorAll('link[as="style"]').forEach((ele) => {
    doc?.document.head.append(ele.cloneNode(true));
  });
  document.head.querySelectorAll('link[rel="stylesheet"]').forEach((ele) => {
      doc?.document.head.append(ele.cloneNode(true));
  });
}

export const addStyleToIFrame = (frame_id, file_path) => {
  const iframe = document.getElementById(frame_id);
  if (!iframe) return;

  var cssLink = document.createElement("link");
  cssLink.href = file_path; 
  cssLink.rel = "stylesheet"; 
  cssLink.type = "text/css"; 

  const doc = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument);
  doc?.document.head.append(cssLink);
}

export const iFrameHeightbyContent = (frame_id) => {
  const iframe = document.getElementById(frame_id);
  if (!iframe) return;

  const doc = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument);
  const body = doc.document.body;
  // const html = doc.document.documentElement;

  // const height = Math.max( body.scrollHeight, body.offsetHeight, 
  //                    html.clientHeight, html.scrollHeight, html.offsetHeight );

  let height = body.scrollHeight;
  
  iframe.style.height = height + 'px';
}